import { TIERS, type Tier } from '../lib/types';

interface TierFilterProps {
  value: Tier | undefined;
  onChange: (tier: Tier | undefined) => void;
  disabled?: boolean;
}

function label(tier: Tier): string {
  return tier.charAt(0).toUpperCase() + tier.slice(1);
}

export function TierFilter({ value, onChange, disabled }: TierFilterProps) {
  return (
    <div className="tier-filter" role="radiogroup" aria-label="filter by tier">
      <button
        type="button"
        className="tier-chip"
        role="radio"
        aria-checked={value === undefined}
        onClick={() => onChange(undefined)}
        disabled={disabled}
      >
        All
      </button>
      {TIERS.map((t) => (
        <button
          key={t}
          type="button"
          className="tier-chip"
          role="radio"
          aria-checked={value === t}
          onClick={() => onChange(t)}
          disabled={disabled}
        >
          {label(t)}
        </button>
      ))}
    </div>
  );
}
